var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2933 13.0036C12.1537 13.8722 10.7661 14.3535 9.33333 14.3769C4.66667 14.3769 2 9.04356 2 9.04356C2.82926 7.49815 3.97942 6.14796 5.37333 5.08356M7.93333 3.87022C8.39222 3.76281 8.86204 3.70911 9.33333 3.71022C14 3.71022 16.6667 9.04356 16.6667 9.04356C16.262 9.80063 15.7794 10.5134 15.2267 11.1702M10.7467 10.4569C10.5636 10.6534 10.3428 10.811 10.0974 10.9203C9.8521 11.0296 9.58727 11.0884 9.31873 11.0931C9.05019 11.0979 8.78344 11.0485 8.53441 10.9479C8.28537 10.8473 8.05915 10.6976 7.86923 10.5077C7.67931 10.3177 7.5296 10.0915 7.42901 9.84248C7.32842 9.59345 7.27902 9.3267 7.28376 9.05816C7.28849 8.78962 7.34727 8.52479 7.45658 8.27945C7.5659 8.03412 7.7235 7.81332 7.92 7.63022",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.71027L16.6667 16.3769",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.cafded77012a11a6c55328c82c7f1dad.svg";
export { ForwardRef as ReactComponent };